/* global scheduler */
export function createInstitutes() {
  return {
    namespaced: true,
    state: {
      institutes: [],

      eiByExtRef: {},
      ecByExtRef: {}
    },
    actions: {
      refresh: async ({commit}, institutes) => {
        commit('replaceInstitutes', institutes)

        const eiByExtRef = {}
        const ecByExtRef = {}
        for (const institute of institutes) {
          eiByExtRef[institute.extRef] = institute
          for (const examinationCenter of institute.examinationCenters) {
            eiByExtRef[examinationCenter.extRef] = institute
            ecByExtRef[examinationCenter.extRef] = examinationCenter
          }
          await scheduler.yield()
        }
        commit('replaceEiByExtRef', eiByExtRef)
        commit('replaceEcByExtRef', ecByExtRef)
      }
    },
    mutations: {
      replaceInstitutes: (state, value) => {
        state.institutes = value
      },
      replaceEiByExtRef: (state, value) => {
        state.eiByExtRef = value
      },
      replaceEcByExtRef: (state, value) => {
        state.ecByExtRef = value
      }
    }
  }
}
